<template>
    <div>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">{{ ListaDocumento.docId ? 'Alterar documento' : 'Novo documento' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Lista de documentos</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ ListaDocumento.docId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header">
                                <span><v-icon size="20">mdi-file-document-outline</v-icon></span>
                                <div>
                                    <h4>{{ ListaDocumento.docId ? 'Alterar documento' : 'Novo documento' }}</h4>
                                    <p>Preencha os dados e defina a disponibilidade deste cadastro.</p>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="ListaDocumento.docId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Nome</label>
                                            <input v-model="ListaDocumento.docNome"
                                                type="text" class="form-control" placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Visivel</label>
                                            <select v-model="ListaDocumento.docVisivel" class="form-select form-control"
                                                id="defaultSelect">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="TipoPessoas != ''">
                                        <div class="form-group">
                                            <label>Tipo</label>
                                            <select  v-model="ListaDocumento.tpeId" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option v-for="optionTipo in TipoPessoas" :key="optionTipo.tpeId"
                                                    :value="optionTipo.tpeId">{{ optionTipo.tpeNome }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions">
                        <button v-if="ListaDocumento.docId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()"  class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Lista de documentos</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body" v-if="TipoPessoas!=''">
                                <adm-data-table :headers="headers" :items="ListaDocumentos" v-model="itemsSelected" alternating
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina">
                                    <template #item-docVisivel="item">
                                        <span>{{ item.docVisivel ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-tpeId="item">
                                        <span>{{ item.tpeId != null ? TipoPessoas.filter(x=> x.tpeId == item.tpeId)[0].tpeNome : 'GarantePay' }}</span>
                                    </template>
<template #item-actions="item">
    <div class="gp-table-actions">
        <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
        <button v-show="false" type="button" class="gp-table-action gp-action-delete" title="Excluir" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
    </div>
</template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import EasyDataTable from 'vue3-easy-data-table'
export default {
  name: 'CadastroListaDocumentoView',
  components: {
    EasyDataTable
  },
  data: () => ({
    EditView: false,
    ListaDocumento: {
      docId: 0,
      docNome: '',
      docVisivel: '',
      tpeId: ''
    },
    ListaDocumentos: [],
    selectedVisivel: null,
    headers: [
      { text: 'Id', value: 'docId', sortable: true },
      { text: 'Nome', value: 'docNome', sortable: true },
      { text: 'Visivel', value: 'docVisivel', sortable: true },
      { text: 'Tipo', value: 'tpeId', sortable: true },
      { text: 'Ações', value: 'actions' }
    ],
    itemsSelected: [],
    selectedItem: null,
    searchValue: '',
    TipoPessoas: []
  }),
  methods: {
    // edit
    EditNew () {
      this.EditView = true
      this.ListaDocumento.docId = 0
      this.ListaDocumento.docNome = ''
      this.ListaDocumento.docVisivel = ''
      this.ListaDocumento.tpeId = ''
    },
    EditGrid (item) {
      this.EditView = true
      if (item.docId != '') {
        axios.get('/Telas/ListaDocumento/GetById/' + item.docId)
          .then(response => {
            this.ListaDocumento = response.data
          })
      }
    },
    Add () {
      if (this.ListaDocumento.docNome == '') {
        this.$mensagemAviso('Nome Obrigatório.')
      } else if (this.ListaDocumento.docVisivel === '') {
        this.$mensagemAviso('Visível Obrigatório.')
      } else if (this.ListaDocumento.docAtivo === '') {
        this.$mensagemAviso('Ativo Obrigatório.')
      } else {
        axios.post('/Telas/ListaDocumento/Add', this.ListaDocumento)
          .then(response => {
            if (response.data > 0) {
              this.$mensagemAvisoSucesso('Registro Incluído.')
              this.Get()
            }
          })
      }
    },
    Put () {
      if (this.ListaDocumento.docNome == '') {
        this.$mensagemAviso('Nome Obrigatório.')
      } else if (this.ListaDocumento.docVisivel === '') {
        this.$mensagemAviso('Visível Obrigatório.')
      } else if (this.ListaDocumento.docAtivo === '') {
        this.$mensagemAviso('Ativo Obrigatório.')
      } else {
        axios.put('/Telas/ListaDocumento/Update', this.ListaDocumento)
          .then(response => {
            if (response.status == 200) {
              this.$mensagemAvisoSucesso('Registro Alterado.')
              this.Get()
            }
          })
      }
    },
    EditCancel () {
      // window.location.reload();
      this.$router.go(0)
    },
    // edit
    DeleteGrid (item) {
      this.$mensagemConfirma('Tem certeza que deseja excluir?')
        .then((result) => {
          if (result.isConfirmed) {
            // Lógica para excluir o item
            const param1 = item.docId
            axios.delete(`/Telas/ListaDocumento/Delete/${param1}`)
              .then(response => {
                if (response.status == 200) {
                  this.$mensagemAvisoSucesso('Registro Excluido.')
                  this.Get()
                }
              })
          }
        })
    },
    async Get () {
      this.EditView = false
      await axios.get('/Telas/ListaDocumento/GetDados')
        .then(response => {
          this.ListaDocumentos = response.data.listaDocumento
          this.TipoPessoas = response.data.tipoPessoas
        })
    }
  },
  created () {
    this.Get()
  }
}
</script>

<style></style>
